export default __webpack_public_path__ + "static/media/sunra.51aef00e.jpg";